/*jshint esversion: 6 */
import './generalJs';

import { createApp } from 'vue';
import App from '../vue/App_Search.vue';
import router from './router';

import { ServerTable } from 'v-tables-3';
import {markRaw} from 'vue';
import sortIconVue from "./../vue/searchComp/sortIcon.vue";
import VueAwesomePaginate from "vue-awesome-paginate";
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon,FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import { getFawLibrary } from '@js/func.common_new';
library.add(getFawLibrary());

import "vue-awesome-paginate/dist/style.css"; 
//@ts-ignore
import vueForm from '@deliliah/vueform';

createApp(App)
    .component('FontAwesomeIcon', FontAwesomeIcon)
    .component('FontAwesomeLayers',FontAwesomeLayers)
    .use(ServerTable, {}, 'bootstrap4',{
    sortControl: markRaw(sortIconVue)
    })
    .use(vueForm)
    .use(VueAwesomePaginate)
    .use(router)
    .mount('#app');